import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../../../environments/environment.prod";
import { AbstractService } from "../../../../services/abstract.service";
import RouteGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-group/route-group.entity";
const apiUrl = env.API_AVE_INTEGRATOR_URL;
const moduleName = env.PATH_BP_INTEGRATOR;

@Injectable({
  providedIn: "root",
})
export class BusinessPartnerIntegratosServicesService extends AbstractService<RouteGroupAttributes,any,any> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  sincronize(ids): Observable<any>{
    if(!moduleName){
      console.warn('No se construyó API porque moduleName es null');
      return of(null);
    }
    
    const API_URL: string = apiUrl + `api/${moduleName}/sendBusinessPartners`;
    return this.http.post<any>(API_URL, ids);
  }
}
